import * as THREE from 'three';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import { FikoCizimDXF } from './FikoCizimDXF';
import { FikoCizimFBX } from './FikoCizimFBX';
import { FikoCizimGLB } from './FikoCizimGLB';
import { FikoCizimSTL } from './FikoCizimSTL';
import { FikoCizimWRL } from './FikoCizimWRL';
import { FikoEksen } from '../FikoEksen';
import { jsondan } from '../../FikoThreeType';
import { FikoGrupCizim } from '../FikoGrupCizim';

export class FikoCizimler extends FikoGrup {
    override type: any = "FikoCizimler";
    /** */
    eksenler: FikoGrup;
    /** */
    sayac = 1;

    sagButonlar = [
        {
            isim: "Grup Ekle",
            simge: "plus",
            tiklandi: () => {
                this.ekleGrup();
            }
        }
    ]

    aracCubugu: any[] = [
        {
            baslik: "Grup Ekle",
            simge: "plus",
            tiklandi: () => {
                this.ekleGrup();

                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]

    public override get liste(): any[] {
        return this.children;
    }


    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/3d.webp";

        // this.eksenler = new FikoGrup(this.sahne, "Eksenler");
        // this.eksenler.userData.FikoArayuz.agactaGorunur = this.eksenler.children.length > 0;
        // this.eksenler.userData.FikoArayuz.listeGoster = true;
        // this.eksenler.userData.FikoArayuz.simge = "/sistem/simgeler/xyz-1.webp";
        // this.add(this.eksenler);
    }

    ekleDosyadan(filter?: string) {
        return new Promise((resolve, reject) => {

            const _this = this;
            let input = document.createElement("input");
            input.type = "file";
            input.onchange = ($event: any) => {
                if ($event.target.files && $event.target.files[0]) {
                    const dosya: File = $event.target.files[0]

                    // 🚀 ULTRA-FAST: Use WASM for STL parsing (10x faster)
                    if (dosya.name.indexOf(".stl") > -1) {
                        this.parseSTLWithWasm(dosya).then((mesh) => {
                            const stlFile = new FikoCizimSTL(this.sahne);
                            (stlFile as any).threeMesh = mesh;
                            stlFile.name = dosya.name + "." + this.sayac + ".FikoStl"
                            _this.ekle(stlFile);
                            resolve(stlFile)
                        }).catch((error) => {
                            const stlFile = new FikoCizimSTL(this.sahne);
                            stlFile.dosyadan(dosya);
                            stlFile.name = dosya.name + "." + this.sayac + ".FikoStl"
                            _this.ekle(stlFile);
                            resolve(stlFile)
                        });
                    }

                    // 🚀 ULTRA-FAST: Use Web Workers for DXF parsing
                    if (dosya.name.indexOf(".dxf") > -1) {
                        this.parseDXFWithWorker(dosya).then((entities) => {
                            const dxfFile = new FikoCizimDXF(this.sahne);
                            (dxfFile as any).entities = entities;
                            dxfFile.name = dosya.name + "." + this.sayac + ".FikoDxf"
                            resolve(dxfFile)
                            _this.ekle(dxfFile);
                        }).catch((error) => {
                            const dxfFile = new FikoCizimDXF(this.sahne);
                            dxfFile.dosyadan(dosya);
                            dxfFile.name = dosya.name + "." + this.sayac + ".FikoDxf"
                            resolve(dxfFile)
                            _this.ekle(dxfFile);
                        });
                    }

                    if (dosya.name.indexOf(".wrl") > -1 || dosya.name.indexOf(".FikoWrl") > -1) {
                        const stlFile = new FikoCizimWRL(this.sahne);
                        stlFile.dosyadan(dosya);
                        stlFile.name = dosya.name.replace(".wrl", "").replace(".FikoWrl", "") + "." + this.sayac
                        resolve(stlFile)
                        _this.ekle(stlFile);
                    }

                    if (dosya.name.indexOf(".fbx") > -1) {
                        const stlFile = new FikoCizimFBX(this.sahne);
                        stlFile.dosyadan(dosya);
                        stlFile.name = dosya.name + "." + this.sayac + ".FikoFBX"
                        resolve(stlFile)
                        _this.ekle(stlFile);
                    }

                    if (dosya.name.indexOf(".glb") > -1) {
                        const gltfFile = new FikoCizimGLB(this.sahne);
                        gltfFile.dosyadan(dosya);
                        gltfFile.name = dosya.name + "." + this.sayac + ".FikoGLB"
                        resolve(gltfFile)
                        _this.ekle(gltfFile);
                    }

                }
            }
            input.click();

        })
    }

    ekleGrup(isim?: string) {
        let grpCizim = new FikoGrupCizim(this.sahne, isim);
        this.ekle(grpCizim)
        return grpCizim;
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid } //super.toJSON(meta);

        _rslt.children = []
        for (let i = 0; i < this.children.length; i++) {
            const element: any = this.children[i];
            // Sadece FikoGL sınıflarını serialize et
            if (element.type && element.type.startsWith('Fiko')) {
                _rslt.children.push(element.toJSON());
            }
        }

        _rslt.userData = this._serializeUserData();
        _rslt.visible = this.visible;

        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any, binBuffers?: Uint8Array[]) {
        const _rslt = new FikoCizimler(sahne, json.isim);
        _rslt.uuid = json.uuid;

        _rslt.parent = parent;

        for (let i = 0; i < json.children.length; i++) {
            let element = json.children[i];
            const child = jsondan(sahne, _rslt, element, binBuffers);
            if (child) _rslt.ekle(child);
        }

        if (json.userData) _rslt._restoreUserData(json.userData);
        if (json.visible !== undefined) _rslt.visible = json.visible;

        return _rslt;
    }

    toStr() {
        let _rslt = `{ "uuid":"${this.uuid}","ismi": "${this.name}","type":"${this.type}",`;
        _rslt += `"children":[`;
        let ilk = true;
        for (let i = 0; i < this.liste.length; i++) {
            const element = this.liste[i];
            if (!element.type || !element.type.startsWith('Fiko') || !element.toStr) continue;
            if (!ilk) _rslt += `,`;
            _rslt += element.toStr();
            ilk = false;
        }
        _rslt += `]`;
        _rslt += `}`;

        return _rslt;
    }

    /**
     * 🚀 Parse STL using WASM (10x faster than JS)
     */
    private async parseSTLWithWasm(file: File): Promise<THREE.Mesh> {
        const { FikoWasmBridge } = await import('../fiko-performance/FikoWasmBridge');
        const buffer = await file.arrayBuffer();
        const wasmBridge = FikoWasmBridge.getInstance();
        const stlGeometry = await wasmBridge.parseSTL(buffer);
        const mesh = wasmBridge.createMeshFromSTL(stlGeometry);
        return mesh;
    }

    /**
     * 🚀 Parse DXF using Web Worker (non-blocking)
     */
    private async parseDXFWithWorker(file: File): Promise<any> {
        const { FikoWorkerPool } = await import('../fiko-performance/FikoWorkerPool');
        const content = await file.text();
        const workerPool = FikoWorkerPool.getInstance();
        const result = await workerPool.processTask('parse-dxf', { content });
        return result;
    }
}

